export default "__VITE_ASSET___xq5iLuI__"